import Hero from "@/components/Hero";
import PackagesSection from "@/components/PackagesSection";
import BookingSection from "@/components/BookingSection";
import AboutContact from "@/components/AboutContact";
import Newsletter from "@/components/Newsletter";
import FAQSection from "@/components/FAQSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import MenuSection from "@/components/MenuSection";
import ComfortToolsSection from "@/components/ComfortToolsSection";
import SEODirectory from "@/components/SEODirectory";
import useSEO from "@/hooks/useSEO";

export default function Home() {
    useSEO({
        title: "Massothérapie à Blainville et Rive-Nord · Jérémy Tessier",
        description:
            "Massothérapie bien-être à Blainville — massage classique, signature, biocorporel et enrichi. Cabinet chaleureux desservant la Rive-Nord. Réservation en ligne.",
        canonical: "https://massoclic.ca/",
        ogImage: "https://massoclic.ca/icon.svg",
    });
    return (
        <main data-testid="home-page">
            <Hero />
            <MenuSection />
            <ComfortToolsSection />
            <PackagesSection />
            <TestimonialsSection />
            <BookingSection />
            <FAQSection />
            <AboutContact />
            <SEODirectory />
            <Newsletter />
        </main>
    );
}
